'use strict';

var _vanillaMasker = require('vanilla-masker');

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

require('./input-donation.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$$('.ll-input-donation').each(function () {
	var $donation = $$(this),
	    $input = $donation.find('.ll-input-donation__input'),
	    $switch = $donation.find('.ll-input-donation__switch'),
	    $buttons = $donation.find('.ll-input-donation__button'),
	    $hidden = $donation.find('.ll-input-donation__hidden');

	(0, _vanillaMasker2.default)($input).maskMoney({
		precision: 0,
		separator: ',',
		delimiter: '.',
		unit: 'R$',
		zeroCents: false
	});

	$input.on('blur', function (event) {
		var value = _vanillaMasker2.default.toNumber($input.val());

		$hidden.val(value);
		$hidden.trigger('change', $hidden.val());
		$buttons.removeClass('is-active');
	});

	$switch.on('change', function (event) {
		$$('.ll-app').toggleClass('ll-app--primary');
		$$('.ll-app').toggleClass('ll-app--secondary');

		var isMonthly = $$('.ll-app').hasClass('ll-app--secondary');

		// $buttons.removeClass('is-active')
		$input.prop('disabled', isMonthly);
		$donation.trigger('monthly-change', isMonthly);
		$input.prop('placeholder', isMonthly ? 'Selecione um valor abaixo' : 'R$');
		$donation[0].validate();
	});

	$buttons.each(function () {
		var $button = $$(this),
		    value = $button.data('value'),
		    code = $button.data('code');

		$button.on('click', function (event) {
			$buttons.removeClass('is-active');
			$button.addClass('is-active');

			$input.val(null);
			$hidden.val(value);
			$donation.trigger('code-change', code);
			$hidden.trigger('change', $hidden.val());

			event.preventDefault();
		});
	});

	$donation[0].validate = function () {
		var isMonthly = $$('.ll-app').hasClass('ll-app--secondary');
		var isButtonActive = function isButtonActive() {
			var active = false;

			$buttons.each(function () {
				if ($$(this).hasClass('is-active')) active = true;
			});

			return active;
		};

		if (isMonthly && !isButtonActive() || !isMonthly && $input.val().length == 0 && !isButtonActive()) {
			$donation.addClass('is-invalid');
			return false;
		}

		$donation.removeClass('is-invalid');
		return true;
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/components/input/input-donation.js
// module id = 89
// module chunks = 0